import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "portal-dashboard pa-4" }
const _hoisted_2 = { class: "greeting-section mb-6" }
const _hoisted_3 = { class: "greeting-title" }
const _hoisted_4 = { class: "greeting-sub text-medium-emphasis" }
const _hoisted_5 = { class: "kpi-value text-green-darken-2" }
const _hoisted_6 = { class: "kpi-sub text-medium-emphasis" }
const _hoisted_7 = { class: "kpi-sub text-medium-emphasis" }
const _hoisted_8 = { class: "action-title" }
const _hoisted_9 = { class: "action-sub text-medium-emphasis text-caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "text-center py-8"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "red-darken-1",
                  size: "48"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_ctx.dashboard)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h2", _hoisted_3, [
                _cache[0] || (_cache[0] = _createTextVNode("Bună ziua, ", -1)),
                _createElementVNode("strong", null, _toDisplayString(_ctx.dashboard.NumeAngajat), 1),
                _cache[1] || (_cache[1] = _createTextVNode("!", -1))
              ]),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.dashboard.Departament) + " · " + _toDisplayString(_ctx.dashboard.Functie), 1)
            ]),
            _createVNode(_component_v_row, { class: "mb-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "kpi-card",
                      color: "green-lighten-5",
                      elevation: "2",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "text-center py-5" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "40",
                              color: "green-darken-2",
                              class: "mb-2"
                            }, {
                              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode("mdi-umbrella-beach", -1)
                              ]))]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.dashboard.ZileCODisponibile), 1),
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "kpi-label" }, "Zile CO disponibile", -1)),
                            _createElementVNode("div", _hoisted_6, "Folosite: " + _toDisplayString(_ctx.dashboard.ZileCOFolosite), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "kpi-card",
                      color: _ctx.dashboard.CereriConcediuInAsteptare > 0 ? 'amber-lighten-5' : 'grey-lighten-5',
                      elevation: "2",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "text-center py-5" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "40",
                              color: _ctx.dashboard.CereriConcediuInAsteptare > 0 ? 'amber-darken-2' : 'grey',
                              class: "mb-2"
                            }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode("mdi-clock-outline", -1)
                              ]))]),
                              _: 1
                            }, 8, ["color"]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["kpi-value", _ctx.dashboard.CereriConcediuInAsteptare > 0 ? 'text-amber-darken-2' : 'text-grey'])
                            }, _toDisplayString(_ctx.dashboard.CereriConcediuInAsteptare), 3),
                            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "kpi-label" }, "Cereri în așteptare", -1)),
                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "kpi-sub text-medium-emphasis" }, "Concedii", -1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "kpi-card",
                      color: _ctx.dashboard.TicheteInAsteptare > 0 ? 'blue-lighten-5' : 'grey-lighten-5',
                      elevation: "2",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "text-center py-5" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "40",
                              color: _ctx.dashboard.TicheteInAsteptare > 0 ? 'blue-darken-2' : 'grey',
                              class: "mb-2"
                            }, {
                              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                _createTextVNode("mdi-ticket-outline", -1)
                              ]))]),
                              _: 1
                            }, 8, ["color"]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["kpi-value", _ctx.dashboard.TicheteInAsteptare > 0 ? 'text-blue-darken-2' : 'text-grey'])
                            }, _toDisplayString(_ctx.dashboard.TicheteInAsteptare), 3),
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "kpi-label" }, "Tichete deschise", -1)),
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "kpi-sub text-medium-emphasis" }, "HR", -1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "6",
                  md: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "kpi-card",
                      color: _ctx.dashboard.PontajPlecareLipsaAzi ? 'red-lighten-5' : 'green-lighten-5',
                      elevation: "2",
                      rounded: "xl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { class: "text-center py-5" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "40",
                              color: _ctx.dashboard.PontajPlecareLipsaAzi ? 'red-darken-2' : 'green-darken-2',
                              class: "mb-2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.dashboard.PontajPlecareLipsaAzi ? 'mdi-door-open' : 'mdi-check-circle'), 1)
                              ]),
                              _: 1
                            }, 8, ["color"]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["kpi-value", _ctx.dashboard.PontajPlecareLipsaAzi ? 'text-red-darken-2' : 'text-green-darken-2'])
                            }, _toDisplayString(_ctx.dashboard.PontajPlecareLipsaAzi ? '!' : 'OK'), 3),
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "kpi-label" }, "Pontaj azi", -1)),
                            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.dashboard.PontajPlecareLipsaAzi ? 'Plecare lipsă' : 'Complet'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actiuniRapide, (act) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "3",
                    key: act.route
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "action-card",
                        elevation: "1",
                        rounded: "xl",
                        onClick: ($event: any) => (_ctx.$router.push({ name: act.route })),
                        ripple: true,
                        style: {"cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, { class: "d-flex align-center pa-4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_avatar, {
                                color: act.color,
                                size: "44",
                                class: "mr-3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    color: "white",
                                    size: "22"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(act.icon), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["color"]),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_8, _toDisplayString(act.title), 1),
                                _createElementVNode("div", _hoisted_9, _toDisplayString(act.sub), 1)
                              ]),
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_icon, { color: "grey-lighten-1" }, {
                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                  _createTextVNode("mdi-chevron-right", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ], 64))
        : (_ctx.error)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 2,
              type: "error",
              variant: "tonal"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.error), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
  ]))
}